import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import Gif from "./../../assets/loading-gif-png-5.gif";
import UploadGif from "./../../assets/output-onlinegiftools.gif";
import Box from "../../components/Box";
import { AuthContext } from "../../App";
import { Axios } from "../../config/axios.js";
import { Navbar, SubNav } from "../../components";
import SampleFile from "../../assets/samples/collection_sample.xlsx"
import { FaRecycle, FaUserAlt } from "react-icons/fa"
import { BsCashStack, BsCash } from "react-icons/bs"
import * as xlsx from "xlsx";
import "./dashboard.css";
const Dashboard = () => {
    const navigate = useNavigate();
    const [user, setUser] = useContext(AuthContext);
    const [file, setFile] = useState();
    const [notFound, setNotFound] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [filtering, setFiltering] = useState(true);

    const [count, setCount] = useState("");
    const [sum, setSum] = useState("");
    const [act70, setAct70] = useState("");
    const [act106, setAct106] = useState("");
    const [act211, setAct211] = useState("");
    const [disabilityIns, setDisabilityIns] = useState("");
    const [indContribution, setIndContribution] = useState("");
    const [loansConsolidated, setLoansConsolidated] = useState("");

    const [fiscalYearUnq, setFiscalYearUnq] = useState([]);
    const [fiscalYear, setFiscalYear] = useState("");
    const [monthUnq, setMonthUnq] = useState([]);
    const [month, setMonth] = useState("");
    const [actUnq, setActUnq] = useState([]);
    const [act, setAct] = useState("");
    const [agencyUnq, setAgencyUnq] = useState([]);
    const [agency, setAgency] = useState('');
    const [agencyCodeUnq, setAgencyCodeUnq] = useState([]);
    const [agencyCode, setAgencyCode] = useState("");

    useEffect(() => {
        // var data = agency.map((a) => a.value);
        // console.log(data);
        const GetData = async () => {
            setFiltering(true);
            await Axios.get(
                `/collection/getAll?agency=${agency}&fiscalYear=${fiscalYear}&month=${month}`,
                {
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                }
            )
                .then(function (response) {
                    console.log(response);
                    if (response.data.length < 1) {
                        setNotFound(true);
                        setLoading(false);
                    } else {
                        setFiltering(false);
                        setNotFound(false);
                        setLoading(false);
                        console.log(response);
                        if (response.status === 200) {
                            setCount(response.data[0].myCount);
                            setSum(response.data[0].value);
                            setAct70(response.data[0].act70);
                            setAct106(response.data[0].act106);
                            setAct211(response.data[0].act211);
                            setDisabilityIns(response.data[0].disabilityIns);
                            // setIndContribution(response.data[0].indContribution);
                            setLoansConsolidated(response.data[0].loansConsolidated);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            //   setLoading(false);
            //   var a = JSON.parse(agency);
            //   var data = JSON.stringify(agency);
            //   products = data.products;

            //   a.map((v) => {
            //   });
        };

        GetData();
    }, [act, agency, agencyCode, fiscalYear, month, navigate, user, user?.token]);

    useEffect(() => {
        const GetData = async () => {
            setFiltering(true);

            await Axios.get(`/collection/getUniqueAgencyCode`, {
                // gender: "Female",
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    // handle success
                    if (response.status == 200) {
                        setAgencyCodeUnq(response.data);
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });

            // Get Unique Agency
            await Axios.get(`/collection/getUniqueAgency`, {
                // gender: "Female",
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    // handle success
                    if (response.status == 200) {
                        setAgencyUnq(response.data);
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });

            await Axios.get(`/collection/getFiscalYear`, {
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    if (response.status == 200) {
                        setFiscalYearUnq(response.data);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

            // Get Unique  Indicator Of Retrirees
            await Axios.get(`/collection/getUniqueMonth`, {
                // gender: "Female",
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    // handle success
                    if (response.status === 200) {
                        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                        var ab = response.data.sort(function (a, b) {
                            return months.indexOf(a)
                                - months.indexOf(b);
                        });
                        setMonthUnq(ab);
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });


        };

        GetData();
    }, [user?.token]);

    const UpdateData = async () => {
        setIsUploading(true);

        const reader = new FileReader();
        reader.onload = (e) => {
            // var data_chunks = [];
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);

            function chunkArray(myArray, chunk_size) {
                var index = 0;
                var arrayLength = myArray.length;
                var tempArray = [];
                for (index = 0; index < arrayLength; index += chunk_size) {
                    var myChunk = myArray.slice(index, index + chunk_size);
                    // Do something if you want with the group
                    tempArray.push(myChunk);
                }
                return tempArray;
            }

            var result = chunkArray(json, 30000);
            console.log(result);
            // setLoading(true)

            // var i = 0;
            result.forEach(async (v, i) => {
                // console.log(v)
                await Axios.post(`/collection/uploadAll`, v, {
                    // headers: {
                    //     Authorization: `Bearer ${user?.token}`,
                    // },
                })
                    .then(function (response) {
                        console.log(response);
                        // setIsUploading(false)
                        // alert("Data Updated Successfully ")
                        if (result.length === i + 1) {
                            setIsUploading(false);
                        }
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                        // setIsUploading(false)
                        alert("An Error Occured");
                    });
                // Get Unique Retirement System
            });
        };
        reader.readAsArrayBuffer(file);
        // setLoading(false)
    };

    const EarseData = async () => {
        setIsDeleting(true);
        await Axios.delete(`/collection/deleteAll`, {
            // headers: {
            //     Authorization: `Bearer ${user?.token}`,
            // },
        })
            .then(function (response) {
                console.log(response);
                setIsDeleting(false);
                // setIsUploading(false)
                // alert("Data Updated Successfully ")
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                // setIsUploading(false)
                // alert("An Error Occured")
            });
    };

    let getMonthName = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);

        // Using the browser's default locale.
        return date.toLocaleString([], { month: 'short' });
    }
    return (
        <div>
            {loading ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "200px",
                    }}
                >
                    <img src={Gif} alt="" width="150px" />
                    <h1>Loading....</h1>
                </div>
            ) : (
                <section className="update_container">
                    <h3>Welcome to Collections Details</h3>
                    {isUploading ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img src={UploadGif} alt="" style={{ maxWidth: "150px" }} />
                            <div>
                                <h1>Please wait file is uploading...</h1>
                                <p>Don't close window</p>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {/* <h3>UPDATE DATA</h3> */}
                            <input
                                type="file"
                                placeholder="Upload OR Drag File Here"
                                className="update_feild"
                                onChange={(e) => setFile(e.target.files[0])}
                                accept=".xlsx"
                            />
                            <button className="update_btn" onClick={() => UpdateData()}>
                                UPLOAD
                            </button>
                            <p>Only Excel .xlsx File</p>
                            <br />
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button className="_deleteBTn" onClick={() => EarseData()}>
                                    {isDeleting ? "Wait, Earasing Data....." : "Earse All Data"}
                                </button>

                                <a href={SampleFile} download>
                                    <button className="_downloadBTn" >
                                        Download Sample File
                                    </button>
                                </a>
                            </div>
                        </div>
                    )}

                    {/* <SubNav  /> */}
                    <br />
                    <div className="filter">

                        <Select
                            onChange={(selectedOption) => setAgency(selectedOption.value)}
                            options={[
                                { value: "", label: "Get All" },
                                ...agencyUnq.map((t) => ({ value: t, label: t })),
                            ]}
                            // isMulti
                            placeholder="Agency"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles, backgroundColor: "#f2f2f2",
                                    borderRadius: '15px',
                                    width: "320px",
                                    "@media (max-width: 768px)": {
                                        width: '270px'
                                    }
                                }),
                            }}
                        />


                        <Select
                            onChange={(selectedOption) => setFiscalYear(selectedOption.value)}
                            options={[
                                { value: "", label: "Get All" },
                                ...fiscalYearUnq.map((t) => ({ value: t, label: t })),
                            ]}
                            placeholder="Fiscal Year"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles, backgroundColor: "#f2f2f2",
                                    borderRadius: '15px',
                                    width: "280px",
                                    "@media (max-width: 768px)": {
                                        width: '270px'
                                    }
                                }),
                            }}
                        />
                        <Select
                            onChange={(selectedOption) => setMonth(selectedOption.value)}
                            options={[
                                { value: "", label: "Get All" },
                                ...monthUnq.map((t) => ({ value: t, label: getMonthName(t) })),
                            ]}
                            placeholder="Month"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles, backgroundColor: "#f2f2f2",
                                    borderRadius: '15px',
                                    width: "280px",
                                    "@media (max-width: 768px)": {
                                        width: '270px'
                                    }
                                }),
                            }}
                        />
                    </div>

                    {notFound ? (
                        <div>No Record Found</div>
                    ) : (
                        <div className="box_container">
                            {/* <Box value={count} title="Quantity" loading={filtering} /> */}
                            <Box
                                value={sum?.toLocaleString("en-US") || "Loading.."}
                                title="Total Loan"
                                loading={filtering}
                                icon={<BsCash color='#fff' size='34' />}
                            />
                            <Box
                                value={act106?.toLocaleString("en-US")}
                                title="Individual Contribution 106:"
                                loading={filtering}
                            />
                            <Box
                                // value={
                                //     '00'.toLocaleString("en-US") ||
                                //     "Loading.."
                                // }
                                value={disabilityIns?.toLocaleString("en-US")}
                                title="Disability"
                                loading={filtering}
                            />
                            <Box
                                value={act70?.toLocaleString("en-US") || "Loading.."}
                                title="Act 70"
                                loading={filtering}
                            />
                            <Box
                                value={act211?.toLocaleString("en-US") || "Loading.."}
                                // value="Comimng soon!"
                                title="Act 211"
                                loading={filtering}
                            />

                            <Box
                                value={
                                    loansConsolidated?.toLocaleString("en-US") || "Loading.."
                                }
                                title="Loans Consolidated"
                                loading={filtering}
                            />
                            {/* 
              <Box
                value={indContribution?.toLocaleString("en-US") || "Loading.."}
                title="Ind. Contribution 2016-2017"
                loading={filtering}
              /> */}
                        </div>
                    )}
                </section>
            )}
        </div>
    );
};

export default Dashboard;
